module.exports = __webpack_public_path__ + "media/images/ecute/ecutetokyo_ko-3f431ecab3bc19d5edc4e39f76542b93.jpg";